import React, { useContext, useReducer } from "react";

import GlobalContext from "../../isp._comun/iu/contexto/GlobalContext";

import {
    NotificacionToastDeCreacion,
    // NotificacionToastDeError,
} from "../../isp._comun/iu/componentes/widgets/notificacionesToast/NotificacionesToast";

import * as TipoDeError from "../../isp._comun/services/Errores";

import AsociadoReducer from "../reductores/AsociadoReducer";
import * as Action from "../reductores/acciones/dispatch/_ActionsDispatch";
import CargaDeAsociadoConsultado from "../reductores/acciones/dispatch/CargaDeAsociadoConsultado";
import FinalizarComando from "../reductores/acciones/dispatch/FinalizarComando";

import DialogoAsociadoLayout from "./layouts/DialogoAsociadoLayout";

import ComandoAPI from "../../isp._comun/iu/componentes/ComandoAPI";
import { TipoDeAsociado } from "../../isp.žapi.asociados/constantesApiAsociados";
import DataDeRespuestas_de_Asociado from "../../isp.žapi.asociados/DataEstaticaDeRespuestas.json";
import ServiceRegistroDeAsociado from "../../isp.žapi.asociados/ServiceRegistroDeAsociado";
import ServiceActualizacionDeAsociado from "../../isp.žapi.asociados/ServiceActualizacionDeAsociado";
import ServiceQueryUnAsociado from "../../isp.žapi.asociados/ServiceQueryUnAsociado";

// import CodigoDeError from "../../../all/presentadores/CodigosDeErrorDeRespuestas.json";
// import DataDeRespuestas_Comun from "../../../all/presentadores/DataEstaticaDeRespuestas.json";
// import { ModosOp } from "../../../_comun/Constantes";
// import EsperarAsociadoConsultado from "../../reductores/acciones/dispatch/EsperarAsociadoConsultado";
// import { dispatchGeneral } from "../../../_comun/presentadores/dispatchGeneral";
// import useHandlerDeServicio from '../../../_comun/presentadores/useHandlerDeServicioQueUsaSesionId'
// import useHandlerDeComandoConSesionActiva from "../../isp.pantalla.principal/componentes/useHandlerDeComandoConSesionActiva";

const DialogoAsociado = ({ ventana }) => {
    const {
        // estadoPrin,
        // dispatchPrincipal,
        // cargarPantallaLogin,
        handleErroresExtraEnPrincipal,
        notificar,
    } = useContext(GlobalContext);

    //actualiza estadoInicial de la entrada si hay algun input
    /* let funcionEstadoInicial = null;
    if(ventana.estadoCom.flag.modoOperacion === ModosOp.CREAR){
        funcionEstadoInicial = Estado.getEstadoInicial;
    }
    if(ventana.estadoCom.flag.cargandoEntidad){
        const estadoInicial = Estado.getEstadoInicial();
        funcionEstadoInicial = () =>{
            estadoInicial.flag.modal=
        }
    }
    const [estadoDCF, dispatchDCF] = useReducer(FactReducer, null, funcionEstadoInicial); */
    // const [estadoDCF, dispatchDCF] = useReducer(FactReducer, estadoInicial);
    // const [estadoDCF, dispatchDCF] = useReducer(FactReducer, Estado.getEstadoInicial());
    // const estadoDCF = ventana.estadoDCF;

    /* if (
        estadoDCF.flag.iniciando &&
        ventana.estadoCom.flag.modoOperacion !== ModosOp.CREAR
        ) {
            const estadoInicial = ventana.estadoCom
            ventana.estadoCom = estadoDCF;
            ventana.dispatch = dispatchDCF;
            dispatchDCF(new EsperarAsociadoConsultado(estadoInicial));
            return;
        } */

    const [estadoDCF, dispatchDCF] = useReducer(AsociadoReducer, ventana.estadoComp);
    // ventana.estadoComp = estadoDCF;
    // ventana.dispatch = dispatchDCF;

    const serviceApiRegistrarAsociado = new ServiceRegistroDeAsociado();
    const registrarAsociadoCommand = new ComandoAPI(serviceApiRegistrarAsociado);
    registrarAsociadoCommand.ejecutar = async () => {
        const bloqueIdentificacion = {
            tipoDoc: estadoDCF.domain.screen.tipoDoc,
            nroDoc: estadoDCF.domain.screen.nroDoc,
            nombres: estadoDCF.domain.screen.nombres,
            apellidos: estadoDCF.domain.screen.apellidos,
            sexo: estadoDCF.domain.screen.sexo,
        };

        const asociado = {
            ...bloqueIdentificacion,

            general: {
                telcel1: estadoDCF.domain.screen.general.telcel1,
                telcel2: estadoDCF.domain.screen.general.telcel2,
                telfijo: estadoDCF.domain.screen.general.telfijo,
                email: estadoDCF.domain.screen.general.email,
                sitioWeb: estadoDCF.domain.screen.general.sitioWeb,
            },
        };

        try {
            const dataRegistradaDeAsociado = await serviceApiRegistrarAsociado.ejecutar(asociado);
            dispatchDCF(new Action.CargaDeAsociadoRegistrado(dataRegistradaDeAsociado));
            notificar(
                new NotificacionToastDeCreacion(
                    DataDeRespuestas_de_Asociado.CreacionAsociadoAFacturar.titulo,
                    DataDeRespuestas_de_Asociado.CreacionAsociadoAFacturar.mensaje,
                    dataRegistradaDeAsociado.idAsociado
                )
            );
        } catch (error) {
            if (error instanceof TipoDeError.ListaDeErroresDelDominio) {
                dispatchDCF(new Action.CargaDeErroresDelDominioAlCrearAsociado(error.data));
                return;
            }

            /* if (error instanceof TipoDeError.ErrorEnIdSesion) {
                cargarPantallaLogin();
                return;
            } */
            if (error instanceof TipoDeError.ErrorTecnico) {
                dispatchDCF(new Action.FinalizarComando());

                /* let nombreDeError = error.constructor.name;
                notificar(
                    new NotificacionToastDeError(
                        DataDeRespuestas_Comun[nombreDeError].titulo,
                        DataDeRespuestas_Comun.labelCodigoError,
                        CodigoDeError[nombreDeError],
                        DataDeRespuestas_Comun[nombreDeError].descripcion
                    )
                ); */
            }
            handleErroresExtraEnPrincipal(error);
        }
    };
    // });

    const serviceApiActualizacionDeAsociado = new ServiceActualizacionDeAsociado();
    const actualizarAsociadoCommand = new ComandoAPI(serviceApiActualizacionDeAsociado);
    actualizarAsociadoCommand.ejecutar = async () => {
        const asociadoAFactPorActualizar = {
            id: estadoDCF.domain.screen.idAsociado,
            data: estadoDCF.domain.update,
        };

        try {
            // const dataDeAsociadoActualizado =
            await serviceApiActualizacionDeAsociado.ejecutar(asociadoAFactPorActualizar);
            dispatchDCF(
                new Action.CargaDeAsociadoActualizado()
                // new Action.CargaDeAsociadoActualizado(dataDeAsociadoActualizado)
            );
        } catch (error) {
            if (error instanceof TipoDeError.ListaDeErroresDelDominio) {
                // const dataDeRespuestaErronea = error.data;
                dispatchDCF(new Action.CargaDeErroresDelDominioAlActualizarAsociado(error.data));
                return;
            }
            if (error instanceof TipoDeError.ErrorTecnico) {
                dispatchDCF(new Action.FinalizarComando());
                /* let nombreDeError = error.constructor.name;
                notificar(
                    new NotificacionToastDeError(
                        DataDeRespuestas_Comun[nombreDeError].titulo,
                        DataDeRespuestas_Comun.labelCodigoError,
                        CodigoDeError[nombreDeError],
                        DataDeRespuestas_Comun[nombreDeError].descripcion
                    )
                    /* new NotificacionToastDeError(
                        DataDeRespuestas_Comun[nombreDeError].titulo,
                        DataDeRespuestas_Comun.labelCodigoError +
                            CodigoDeError[nombreDeError] +
                            "\n" +
                            DataDeRespuestas_Comun[nombreDeError].descripcion
                    ) */
                /*); */
            }
            handleErroresExtraEnPrincipal(error);
        }
    };
    // });

    const serviceApiQueryUnAsociado = new ServiceQueryUnAsociado();
    const buscarUnSoloAsociadoCommand = new ComandoAPI(serviceApiQueryUnAsociado);
    buscarUnSoloAsociadoCommand.ejecutar = async (idAsociado) => {
        try {
            // const respuestaQuery = await new ServicioDeQueryDeUnAsociadoAFacturar().ejecutar("undefinido");
            const respuestaQuery = await serviceApiQueryUnAsociado.ejecutar(idAsociado);
            dispatchDCF(new CargaDeAsociadoConsultado(respuestaQuery.asociado));
            // ventana.ventanaCargando.dispatch(new CargaDeAsociadoConsultado(respuestaQuery.asociado));
            // dispatchQ(new CargaDeAsociadosBuscados(respuestaQuery.asociados));
        } catch (error) {
            /* if (error instanceof TipoDeError.ListaDeErroresDelDominio) {
                // const dataDeRespuestaErronea = error.data;
                dispatchQ(new Action.CargaDeErroresDelDominioAlActualizarAsociado(error.data));
                return;
            }*/
            if (error instanceof TipoDeError.ErrorTecnico) {
                dispatchDCF(new FinalizarComando());
                /* let nombreDeError = error.constructor.name;
                notificar(
                    new NotificacionToastDeError(
                        DataDeRespuestas_Comun[nombreDeError].titulo,
                        DataDeRespuestas_Comun.labelCodigoError,
                        CodigoDeError[nombreDeError],
                        DataDeRespuestas_Comun[nombreDeError].descripcion
                    )
                ); */
            }
            handleErroresExtraEnPrincipal(error);
        }
    };
    // });

    return (
        <DialogoAsociadoLayout
            ventana={ventana}
            estadoDCF={estadoDCF}
            dispatchDCF={dispatchDCF}
            registrarAsociadoCommand={registrarAsociadoCommand}
            actualizarAsociadoCommand={actualizarAsociadoCommand}
            buscarUnSoloAsociadoCommand={buscarUnSoloAsociadoCommand}
        />
    );
};

export default DialogoAsociado;
